import React from 'react';
import Raven from 'raven-js';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { AppContainer } from 'react-hot-loader';
import { render } from 'react-dom';

import MainC from 'root/mainComponent';
import { env_production } from './constants';

injectTapEventPlugin();

renderHot(MainC);

if (env_production) {
  Raven.config('https://31c10e93771f4042b28f2d1774b172d1@sentry.jaits.com.ar/2').install();
} else if (module.hot) {
  module.hot.accept('../mainComponent.js', () => {
    const MainC = require('../mainComponent.js').default;
    renderHot(MainC);
  });
}

function renderHot(Component) {
  render(
    <AppContainer>
      <Component />
    </AppContainer>,
    document.getElementById('root'),
  );
}

/*
window.onerror = function (msg, url, line) {
console.log("Caught[via window.onerror]: '" + msg + "' from " + url + ":" + line);
return true; // same as preventDefault
};

window.addEventListener('error', function (evt) {
console.log("Caught[via 'error' event]:  '" + evt.message + "' from " + evt.filename + ":" + evt.lineno);
console.log(evt); // has srcElement / target / etc
evt.preventDefault();
});
*/



// WEBPACK FOOTER //
// src/core/main.js